import { Popover, message as messageUtil } from 'antd';
import type { ChatMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import { msgExpireDurationOptions } from '@/configs/options';
import styles from './index.module.scss';
import CopyIcon from './images/copy.svg?react';
import ReplyIcon from './images/reply.svg?react';
import DeleteIcon from './images/delete.svg?react';
import FireIcon from './images/fire.svg?react';
import { deleteMessage } from './helpers';
// import SelectIcon from './images/select.svg?react';
// import ForwardIcon from './images/forward.svg?react';
// import TaskIcon from './images/task.svg?react';

interface ContextMenuMessageProps {
  children: React.ReactNode;
  message: ChatMessage;
  chat: Chat;
}

export default function ContextMenuMessage({
  children,
  message,
  chat,
}: ContextMenuMessageProps) {
  const [open, setOpen] = useState(false);

  const msgExpireOption = useMemo(() => {
    const opt = msgExpireDurationOptions.findByValue(chat.expire_duration);
    return {
      tag: opt?.tag,
    };
  }, [chat.expire_duration]);

  const items = [
    {
      label: 'Reply',
      key: 'Reply',
      icon: <ReplyIcon />,
      onClick: () => {
        setOpen(false);
        console.log('Reply', message, chat);
      },
    },
    {
      key: 'Copy',
      label: 'Copy',
      icon: <CopyIcon />,
      description: '',
      danger: false,
      onClick: () => {
        setOpen(false);
        navigator.clipboard.writeText(message.payload);
        messageUtil.success('Copied');
      },
    },
    // {
    //   key: 'Forward',
    //   label: 'Forward',
    //   icon: <ForwardIcon />,
    //   onClick: () => {
    //     setOpen(false);
    //     console.log('Forward', message, chat);
    //   },
    // },
    {
      key: 'Delete',
      label: 'Delete',
      icon: <DeleteIcon />,
      description: (
        <Flex align="center" gap={2}>
          <FireIcon />
          <span>auto-deletes in {msgExpireOption.tag}</span>
        </Flex>
      ),
      danger: true,
      onClick: () => {
        setOpen(false);
        deleteMessage(message, chat);
      },
    },
    // {
    //   key: 'Select',
    //   label: 'Select',
    //   icon: <SelectIcon />,
    //   onClick: () => {
    //     setOpen(false);
    //     console.log('Select', message, chat);
    //   },
    // },
    // {
    //   key: 'Task',
    //   label: 'Task',
    //   icon: <TaskIcon />,
    //   onClick: () => {
    //     setOpen(false);
    //     console.log('Task', message, chat);
    //   },
    // },
  ];

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger={'contextMenu'}
      // arrow={false}
      content={
        <div className={styles.contextMenuMessage}>
          {items.map((item) => (
            <div
              className={cls(styles.contextMenuMessageItem, {
                [styles.danger]: item.danger,
              })}
              key={item.key}
              onClick={item.onClick}
            >
              <div className={styles.itemContent}>
                <div className={styles.label}>{item.label}</div>
                {item.description && (
                  <div className={styles.description}>{item.description}</div>
                )}
              </div>
              <div className={styles.itemIcon}>{item.icon}</div>
            </div>
          ))}
        </div>
      }
    >
      {children}
    </Popover>
  );
}
